var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-product-tour',{attrs:{"visible":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }